












import { Component, Vue, Prop } from 'vue-property-decorator';
import Dictionary from '@/components/Dictionary.vue';
import { dictionary, DictionaryEntry, DictionaryCategories } from '@/dictionary';

@Component({
  name: 'Home',
  components: {
    Dictionary
  }
})
export default class Home extends Vue {

  private get dictionary() {
    return dictionary;
  }

  private get categories() {
    return DictionaryCategories;
  }

}  

